import type { ApprovalChain } from '../approval-chain.model';

export const DEED_RE_ISSUANCE_BOND_CHAIN: ApprovalChain = {
  id: 'deed-re-issuance-bond',
  label: 'Issuance of a Securitized Title Deed with Bond',
  applicationTypes: ['DEED_RE_ISSUANCE_BOND'],
  steps: [
    {
      role: 'FIRST_BANK_USER',
      action: 'Recommend',
      from: ['LOCAL_GOVERNMENT_APPROVED', 'RESUBMITTED', 'SUBMITTED', 'PENDING', 'MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED'],
      to: 'FIRST_BANK_USER_APPROVED',
    },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['FIRST_BANK_USER_APPROVED', 'SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'REGISTRY', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'REGISTRY_RECOMMENDED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED', 'REGISTRY_RECOMMENDED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
